// import React, { useState, useEffect, useRef } from "react";
// // import { handleAIService } from "./AIChatBot/api/ApplyLeave/handleAIService";
// import { handleAIService } from "../AIChatBot/api/ApplyLeave/handleAIService";

// import { bootstrapPolicies } from "../AIChatBot/api/OrgPolicys/policyBootstrap";

// // ─── Inline styles (no external CSS needed) ───────────────────────────────────
// const S = {
//   // Floating button
//   fab: {
//     position: "fixed",
//     bottom: 28,
//     right: 28,
//     width: 56,
//     height: 56,
//     borderRadius: "50%",
//     background: "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)",
//     border: "none",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 20px rgba(108,99,255,0.45)",
//     zIndex: 9999,
//     transition: "transform 0.2s, box-shadow 0.2s",
//   },
//   fabIcon: { fontSize: 24 },

//   // Chat window
//   window: {
//     position: "fixed",
//     bottom: 96,
//     right: 28,
//     width: 370,
//     height: 520,
//     borderRadius: 20,
//     background: "#ffffff",
//     boxShadow: "0 12px 48px rgba(0,0,0,0.18)",
//     display: "flex",
//     flexDirection: "column",
//     overflow: "hidden",
//     zIndex: 9999,
//     fontFamily: "'Segoe UI', sans-serif",
//     animation: "slideUp 0.25s ease",
//   },

//   // Header
//   header: {
//     background: "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)",
//     padding: "14px 18px",
//     display: "flex",
//     alignItems: "center",
//     gap: 10,
//   },
//   avatar: {
//     width: 36,
//     height: 36,
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.25)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: 18,
//   },
//   headerText: { flex: 1 },
//   headerTitle: { color: "#fff", fontWeight: 700, fontSize: 15, margin: 0 },
//   headerSub: { color: "rgba(255,255,255,0.8)", fontSize: 11, margin: 0 },
//   closeBtn: {
//     background: "none",
//     border: "none",
//     color: "#fff",
//     fontSize: 20,
//     cursor: "pointer",
//     lineHeight: 1,
//     padding: 0,
//   },

//   // Messages area
//   messages: {
//     flex: 1,
//     overflowY: "auto",
//     padding: "16px 14px",
//     background: "#f7f8fc",
//     display: "flex",
//     flexDirection: "column",
//     gap: 10,
//   },

//   // Individual bubble
//   bubbleRow: (role) => ({
//     display: "flex",
//     justifyContent: role === "user" ? "flex-end" : "flex-start",
//     alignItems: "flex-end",
//     gap: 6,
//   }),
//   botDot: {
//     width: 28,
//     height: 28,
//     borderRadius: "50%",
//     background: "linear-gradient(135deg, #6C63FF, #48A9FE)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: 13,
//     flexShrink: 0,
//   },
//   bubble: (role) => ({
//     maxWidth: "78%",
//     padding: "10px 14px",
//     borderRadius: role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
//     background: role === "user"
//       ? "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)"
//       : "#ffffff",
//     color: role === "user" ? "#fff" : "#2d2d2d",
//     fontSize: 13.5,
//     lineHeight: 1.55,
//     boxShadow: role === "user"
//       ? "0 2px 8px rgba(108,99,255,0.3)"
//       : "0 1px 4px rgba(0,0,0,0.08)",
//     whiteSpace: "pre-wrap",
//     wordBreak: "break-word",
//   }),

//   // Typing indicator
//   typing: {
//     display: "flex",
//     alignItems: "center",
//     gap: 4,
//     padding: "10px 14px",
//     background: "#fff",
//     borderRadius: "18px 18px 18px 4px",
//     boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//     width: "fit-content",
//   },
//   dot: (delay) => ({
//     width: 7,
//     height: 7,
//     borderRadius: "50%",
//     background: "#6C63FF",
//     animation: "bounce 1.2s infinite",
//     animationDelay: delay,
//   }),

//   // Input area
//   inputArea: {
//     padding: "12px 14px",
//     background: "#fff",
//     borderTop: "1px solid #eee",
//     display: "flex",
//     gap: 8,
//     alignItems: "center",
//   },
//   input: {
//     flex: 1,
//     border: "1.5px solid #e0e0e0",
//     borderRadius: 24,
//     padding: "9px 16px",
//     fontSize: 13.5,
//     outline: "none",
//     fontFamily: "inherit",
//     background: "#f7f8fc",
//     transition: "border-color 0.2s",
//   },
//   sendBtn: {
//     width: 38,
//     height: 38,
//     borderRadius: "50%",
//     background: "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)",
//     border: "none",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//     boxShadow: "0 2px 8px rgba(108,99,255,0.35)",
//     transition: "opacity 0.2s",
//   },
// };

// // ─── Keyframe injection ───────────────────────────────────────────────────────
// const injectStyles = () => {
//   if (document.getElementById("chatbot-keyframes")) return;
//   const style = document.createElement("style");
//   style.id = "chatbot-keyframes";
//   style.textContent = `
//     @keyframes slideUp {
//       from { opacity: 0; transform: translateY(20px); }
//       to   { opacity: 1; transform: translateY(0); }
//     }
//     @keyframes bounce {
//       0%, 60%, 100% { transform: translateY(0); }
//       30%            { transform: translateY(-6px); }
//     }
//     .chatbot-input:focus { border-color: #6C63FF !important; background: #fff !important; }
//     .chatbot-send:disabled { opacity: 0.45; cursor: not-allowed; }
//     .chatbot-fab:hover { transform: scale(1.08); box-shadow: 0 6px 24px rgba(108,99,255,0.55) !important; }
//   `;
//   document.head.appendChild(style);
// };

// // ─── Component ────────────────────────────────────────────────────────────────
// const ChatBot_v2 = () => {
//   const [open, setOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     {
//       role: "assistant",
//       content: "👋 Hi! I'm your OrgGenie assistant.\n\nI can help you:\n• Apply Leave or WFH\n• Answer policy questions\n• Check upcoming holidays\n\nType anything to get started!",
//     },
//   ]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [ready, setReady] = useState(false);
//   const bottomRef = useRef(null);
//   const inputRef = useRef(null);

//   // Inject CSS keyframes once
//   useEffect(() => { injectStyles(); }, []);

//   // Bootstrap policies on mount
//   useEffect(() => {
//     bootstrapPolicies().then(() => setReady(true));
//   }, []);

//   // Scroll to bottom on new message
//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, loading]);

//   // Focus input when chat opens
//   useEffect(() => {
//     if (open) setTimeout(() => inputRef.current?.focus(), 100);
//   }, [open]);

//   const sendMessage = async () => {
//     const text = input.trim();
//     if (!text || loading) return;

//     setInput("");
//     setMessages((prev) => [...prev, { role: "user", content: text }]);
//     setLoading(true);

//     try {
//       const response = await handleAIService(text);
//       setMessages((prev) => [
//         ...prev,
//         { role: "assistant", content: response.message || "Sorry, I couldn't understand that." },
//       ]);
//     } catch (err) {
//       setMessages((prev) => [
//         ...prev,
//         { role: "assistant", content: "⚠️ Something went wrong. Please try again." },
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       sendMessage();
//     }
//   };

//   return (
//     <>
//       {/* Floating Action Button */}
//       <button
//         className="chatbot-fab"
//         style={S.fab}
//         onClick={() => setOpen((o) => !o)}
//         title="Open chat"
//       >
//         <span style={S.fabIcon}>{open ? "✕" : "💬"}</span>
//       </button>

//       {/* Chat Window */}
//       {open && (
//         <div style={S.window}>
//           {/* Header */}
//           <div style={S.header}>
//             <div style={S.avatar}>🤖</div>
//             <div style={S.headerText}>
//               <p style={S.headerTitle}>OrgGenie Assistant</p>
//               <p style={S.headerSub}>
//                 {ready ? "🟢 Online — ask me anything" : "⏳ Loading policies…"}
//               </p>
//             </div>
//             <button style={S.closeBtn} onClick={() => setOpen(false)}>✕</button>
//           </div>

//           {/* Messages */}
//           <div style={S.messages}>
//             {messages.map((msg, i) => (
//               <div key={i} style={S.bubbleRow(msg.role)}>
//                 {msg.role === "assistant" && (
//                   <div style={S.botDot}>🤖</div>
//                 )}
//                 <div style={S.bubble(msg.role)}>{msg.content}</div>
//               </div>
//             ))}

//             {/* Typing indicator */}
//             {loading && (
//               <div style={S.bubbleRow("assistant")}>
//                 <div style={S.botDot}>🤖</div>
//                 <div style={S.typing}>
//                   <div style={S.dot("0s")} />
//                   <div style={S.dot("0.2s")} />
//                   <div style={S.dot("0.4s")} />
//                 </div>
//               </div>
//             )}

//             <div ref={bottomRef} />
//           </div>

//           {/* Input */}
//           <div style={S.inputArea}>
//             <input
//               ref={inputRef}
//               className="chatbot-input"
//               style={S.input}
//               type="text"
//               placeholder="Type a message…"
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={handleKeyDown}
//               disabled={loading}
//             />
//             <button
//               className="chatbot-send"
//               style={S.sendBtn}
//               onClick={sendMessage}
//               disabled={loading || !input.trim()}
//               title="Send"
//             >
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//                 <path d="M22 2L11 13" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                 <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//               </svg>
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ChatBot_v2;

import React, { useState, useEffect, useRef } from "react";
// import { handleAIService } from "./AIChatBot/api/ApplyLeave/handleAIService";
import { handleAIService } from "../AIChatBot/api/ApplyLeave/handleAIService";
import ReactMarkdown from "react-markdown";
// import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import { bootstrapPolicies } from "../AIChatBot/api/OrgPolicys/policyBootstrap";
import "./chat.css";
import "./demook.css"
// ─── Inline styles (no external CSS needed) ───────────────────────────────────
const S = {
  // Floating button
  fab: {
    position: "fixed",
    bottom: 28,
    right: 28,
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 20px rgba(108,99,255,0.45)",
    zIndex: 9999,
    transition: "transform 0.2s, box-shadow 0.2s",
  },
  fabIcon: { fontSize: 24 },

  // Chat window
  window: {
    position: "fixed",
    bottom: 96,
    right: 28,
    width: 370,
    height: 520,
    borderRadius: 20,
    background: "#ffffff",
    boxShadow: "0 12px 48px rgba(0,0,0,0.18)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    zIndex: 9999,
    fontFamily: "'Segoe UI', sans-serif",
    animation: "slideUp 0.25s ease",
  },

  // Header
  header: {
    background: "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)",
    padding: "14px 18px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
  },
  headerText: { flex: 1 },
  headerTitle: { color: "#fff", fontWeight: 700, fontSize: 15, margin: 0 },
  headerSub: { color: "rgba(255,255,255,0.8)", fontSize: 11, margin: 0 },
  closeBtn: {
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: 20,
    cursor: "pointer",
    lineHeight: 1,
    padding: 0,
  },

  // Messages area
  messages: {
    flex: 1,
    overflowY: "auto",
    padding: "16px 14px",
    background: "#f7f8fc",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  // Individual bubble
  bubbleRow: (role) => ({
    display: "flex",
    justifyContent: role === "user" ? "flex-end" : "flex-start",
    alignItems: "flex-end",
    gap: 6,
  }),
  botDot: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #6C63FF, #48A9FE)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    flexShrink: 0,
  },
  bubble: (role) => ({
    maxWidth: "78%",
    padding: "10px 14px",
    borderRadius: role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
    background: role === "user"
      ? "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)"
      : "#ffffff",
    color: role === "user" ? "#fff" : "#2d2d2d",
    fontSize: 13.5,
    lineHeight: 1.55,
    boxShadow: role === "user"
      ? "0 2px 8px rgba(108,99,255,0.3)"
      : "0 1px 4px rgba(0,0,0,0.08)",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  }),

  // Typing indicator
  typing: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "10px 14px",
    background: "#fff",
    borderRadius: "18px 18px 18px 4px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    width: "fit-content",
  },
  dot: (delay) => ({
    width: 7,
    height: 7,
    borderRadius: "50%",
    background: "#6C63FF",
    animation: "bounce 1.2s infinite",
    animationDelay: delay,
  }),

  // Input area
  inputArea: {
    padding: "12px 14px",
    background: "#fff",
    borderTop: "1px solid #eee",
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  input: {
    flex: 1,
    border: "1.5px solid #e0e0e0",
    borderRadius: 24,
    padding: "9px 16px",
    fontSize: 13.5,
    outline: "none",
    fontFamily: "inherit",
    background: "#f7f8fc",
    transition: "border-color 0.2s",
  },
  sendBtn: {
    width: 38,
    height: 38,
    // borderRadius: "50%",
    // background: "linear-gradient(135deg, #6C63FF 0%, #48A9FE 100%)",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: "0 2px 8px rgba(108,99,255,0.35)",
    transition: "opacity 0.2s",
  },
};

// ─── Keyframe injection ───────────────────────────────────────────────────────
const injectStyles = () => {
  if (document.getElementById("chatbot-keyframes")) return;
  const style = document.createElement("style");
  style.id = "chatbot-keyframes";
  style.textContent = `
    @keyframes slideUp {
      from { opacity: 0; transform: translateY(20px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes bounce {
      0%, 60%, 100% { transform: translateY(0); }
      30%            { transform: translateY(-6px); }
    }
    .chatbot-input:focus { border-color: #6C63FF !important; background: #fff !important; }
    .chatbot-send:disabled { opacity: 0.45; cursor: not-allowed; }
    .chatbot-fab:hover { transform: scale(1.08); box-shadow: 0 6px 24px rgba(108,99,255,0.55) !important; }
  `;
  document.head.appendChild(style);
};

// ─── Component ────────────────────────────────────────────────────────────────
const ChatBot_v2 = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);
  const messengerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);


  // Inject CSS keyframes once
  useEffect(() => { injectStyles(); }, []);

  // Bootstrap policies on mount
  useEffect(() => {
    bootstrapPolicies().then(() => setReady(true));
  }, []);

  // Scroll to bottom on new message
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  // Focus input when chat opens
  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 100);
  }, [open]);

  const sendMessage = async () => {
    const text = input.trim();
    if (!text || loading) return;

    setInput("");
    setMessages((prev) => [...prev, { role: "user", content: text }]);
    setLoading(true);

    try {
      const response = await handleAIService(text);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: response.message || "Sorry, I couldn't understand that." },
      ]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "⚠️ Something went wrong. Please try again." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  function handleClickOutside(event) {
    if (
      messengerRef.current &&
      !messengerRef.current.contains(event.target)
    ) {
      messengerRef.current.classList.remove("enter");
      setIsOpen(false);
    }
  }
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        messengerRef.current &&
        !messengerRef.current.contains(event.target)
      ) {
        messengerRef.current.classList.remove("enter");
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleEnter = () => {
    if (!messengerRef.current) return;

    messengerRef.current.classList.toggle("enter");
    setIsOpen((prev) => !prev);
  };

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMessage = { role: "user", content: input };
    setMessages((prev) => [...prev, userMessage]);

    setLoading(true);

    try {
      const response = await handleAIService(input);
      const reply =
        response.message || "Sorry, I couldn't understand that.";

      const botMessage = { role: "assistant", content: reply };
      setMessages((prev) => [...prev, botMessage]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "⚠️ Something went wrong." },
      ]);
    } finally {
      setLoading(false);
      setInput("");
    }
  };
  //     const handleSend = async () => {
  //     setInput('')
  //     if (!input.trim()) return;

  //     const userMessage = { role: "user", content: input };
  //     setMessages((prev) => [...prev, userMessage]);

  //     setLoading(true);

  //     const reply = await queryServer(input);

  //     const botMessage = { role: "assistant", content: reply };
  //     setMessages((prev) => [...prev, botMessage]);

  //     setLoading(false);
  //     setInput("");
  // };

  return (
    <>
      {isOpen && (
        <div className="chat-backdrop" onClick={handleToggle}></div>
      )}


      {/* Chat Window */}
      {/* <div style={S.bubbleRow("assistant")}>
              <div style={S.botDot}>🤖</div>
              <div style={S.typing}>
                <div style={S.dot("0s")} />
                <div style={S.dot("0.2s")} />
                <div style={S.dot("0.4s")} />
              </div>
            </div> */}
      <div className="messenger-box-area" ref={messengerRef}>
        <div className="header-msg">
          <div className="avatar">
            <img src="/images/genie.png" alt="genie" />
          </div>
          <div className="header-text">
            <div className="name">Genie</div>
            <div className="role">Ask anything HR. Get answers in seconds.</div>
          </div>
        </div>


        {/* {open && ( */}
        <div className="chatbody">
          {/* Header */}
          <div className="bubble assistant-bubble">Hi, I'm Genie 👋 I'm new here and growing every day — but ask me anything about leave, benefits and other policies, or anything HR. I'll get you an answer instantly.
            {/* <br />  */}

          </div>

          {/* <button style={S.closeBtn} onClick={() => setOpen(false)}>✕</button> */}
          {/* </div> */}

          {/* Messages */}
          {messages.map((m, i) => (
            <div
              key={i}
              className={`message-row ${m.role === "user" ? "user-row" : "assistant-row"
                }`}
            >
              <div
                className={`bubble ${m.role === "user"
                  ? "user-bubble"
                  : "assistant-bubble"
                  }`}
              >
                <div className="response" >
                  <ReactMarkdown remarkPlugins={[remarkGfm]} breaks={true}>
                    {m.content}
                  </ReactMarkdown>
                </div>

              </div>
            </div>
          ))}
          {loading && (
            <div className="message-row assistant-row">
              <div className="bubble assistant-bubble typing">
                Typing...
              </div>
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>
        <div style={S.messages}>

          {/* {loading && (
            <div style={S.bubbleRow("assistant")}>
              <div style={S.botDot}>🤖</div>
              <div style={S.typing}>
                <div style={S.dot("0s")} />
                <div style={S.dot("0.2s")} />
                <div style={S.dot("0.4s")} />
              </div>
            </div>
          )} */}

          <div ref={bottomRef} />
        </div>

        {/* Input */}
        <div style={S.inputArea}>
          <input
            ref={inputRef}
            className="chatbot-input"
            style={S.input}
            type="text"
            placeholder="Type a message…"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />
          <div className="input-row">
            <button
              // className="chatbot-send"
              className="input"
              style={S.sendBtn}
              onClick={sendMessage}
              disabled={loading || !input.trim()}
              title="Send"
            >
              <span className="send-msg" onClick={handleSend}>
                ➤
              </span>
              {/* <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M22 2L11 13" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg> */}
            </button>
          </div>
          {/* <div className="input-row">
                    <input
                        className="input"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Ask a question"
                        onKeyDown={(e) => e.key === "Enter" && handleSend()}
                    />
                    <span className="send-msg" onClick={handleSend}>
                        ➤
                    </span>
                </div> */}
        </div>

        {/* )} */}
      </div>
      {/* <button
        className="chatbot-fab"
        style={S.fab}
        onClick={() => setOpen((o) => !o)}
        title="Open chat"
      >
        <span style={S.fabIcon}>{open ? "✕" : "💬"}</span>
      </button> */}
      <button
        className="btn rounded-circle btn-messenger"
        onClick={() => { setOpen((o) => !o); handleEnter(); }}
        title="Open messenger"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 18 18"
        >
          <g transform="translate(-1)">
            <path d="M16.25,4H15.125v6.75A1.125,1.125,0,0,1,14,11.875H7.057L5,14.125h5.625L14,17.5V14.125h2.25A1.125,1.125,0,0,0,17.375,13V5.125A1.125,1.125,0,0,0,16.25,4Z" transform="translate(1.625 0.5)"></path>
            <path d="M1.125,0h11.25A1.125,1.125,0,0,1,13.5,1.125V9a1.125,1.125,0,0,1-1.125,1.125H6.75L3.375,13.5V10.125H1.125A1.125,1.125,0,0,1,0,9V1.125A1.125,1.125,0,0,1,1.125,0Z" transform="translate(1)"></path>
          </g>
        </svg>
      </button>
    </>
  );
};

export default ChatBot_v2;
